import React, {useEffect, useState} from "react";
import TextInput from '../../Form/TextInput.tsx';
import Select from '../../Form/Select.tsx';
import { IProfile } from '../../../interface/IProfile.ts';
import { useProfileApi } from '../../../features/auth/hooks/use-profile-api.ts'
import { ApiResponseType } from "../../../features/api/types.ts";
import { iso3166 } from "../../../static/iso3166.js";
import { useListsApi } from "../../../features/auth/hooks/use-lists-api.ts";
import { IOption } from "../../../interface/IOption.ts";
import Form from "../../Form/Form.tsx";
import ApiCheck from '../../Structure/ApiCheck.tsx';
import { useValidators } from "../../../features/functions/validators.tsx";
import { useHelper } from "../../../features/functions/helper.tsx";

const TabOfficialData = ({
    profile,
    setProfile
}:{
    profile:IProfile
    setProfile: Function
}) => {
    const [regionList, setRegionList] = useState<Array<any>>([]);
    const [branchList, setBranchList] = useState<Array<any>>([]);
    const [branchesLoading, setBranchesLoading] = useState<boolean>(true);
    const [regionsLoading, setRegionsLoading] = useState<boolean>(true);

    const [companyJobStatusList, setCompanyJobStatusList] = useState<Array<any>>([]);
    const [companyJobStatusLoading, setCompanyJobStatusLoading] = useState<boolean>(true);

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [responseMessage, setResponseMessage] = useState<string>('');
    const [responseMessageClass, setResponseMessageClass] = useState<string>('');
    const { postProfile } = useProfileApi();
    const [errors, setErrors] = useState<any>({});
    const [unSavedChanges, setUnSavedChanges] = useState(false);
    const { getList } = useListsApi();
    const [apiErrors0, setApiErrors0] = useState<any>();
    const [apiErrors1, setApiErrors1] = useState<any>();
    const [apiErrors2, setApiErrors2] = useState<any>();
    const [apiErrors3, setApiErrors3] = useState<any>();
    const [hasInvalidForm, setHasInvalidForm] = useState(false);

    const [isCompanyAdressPublicType, setIsCompanyAdressPublicType] = useState<boolean>(false);

    const { validateEmail, validateUrl, validatePhone } = useValidators();
    const { checkProfileFieldsForErrors } = useHelper();

    const [formData, setFormData] = useState<IProfile>({
        company_company: profile.company_company ?? '',
        company_department: profile.company_department ?? '',
        company_job_status: profile.company_job_status ?? null,
        company_address: profile.company_address ?? '',
        company_zip: profile.company_zip ?? '',
        company_city: profile.company_city ?? '',
        company_country: profile.company_country ?? '',
        company_phone: profile.company_phone ?? '',
        company_mobile: profile.company_mobile ?? '',
        company_email: profile.company_email ?? '',
        company_web: profile.company_web ?? '',
        branch_sectors: profile.branch_sectors ?? '',
        region: profile.region ?? null,
    });

    const handleChange = (event, name = '', value = null) => {
        setFormData({ ...formData, [name ? name : event.target.name]: value ? value : event.target.value });
        !unSavedChanges && setUnSavedChanges(true);
    };

    const handleSelectChange = (name, value) => {
        setFormData({ ...formData, [name]: value });
        !unSavedChanges && setUnSavedChanges(true);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setUnSavedChanges(false);
        setIsLoading(true);

        if (formData.company_job_status && typeof formData.company_job_status === 'object') {
            formData.company_job_status = formData.company_job_status.value;
        }
        if (formData.branch_sectors && typeof formData.branch_sectors === 'object' && formData.branch_sectors !== null) {
            formData.branch_sectors = formData.branch_sectors.value;
        }
        if (formData.region && typeof formData.region === 'object' && formData.region !== null) {
            formData.region = formData.region.value;
        }

        let formDataClone = structuredClone(formData);
        if (profile.preferred_contact_address_source === 'company') {
            formDataClone.contact_address = formDataClone.company_address;
            formDataClone.contact_city = formDataClone.company_city;
            formDataClone.contact_zip = formDataClone.company_zip;
            formDataClone.contact_country = formDataClone.company_country;
            formDataClone.contact_company = formDataClone.company_company;
            formDataClone.contact_department = formDataClone.company_department;
        }
        if (profile.preferred_contact_email_source === 'company_email') {
            formDataClone.contact_email = formDataClone.company_email;
        }
        if (profile.preferred_contact_phone_source === 'company_mobile') {
            formDataClone.contact_phone = formDataClone.company_mobile;
        }
        if (profile.preferred_contact_phone_source === 'company_phone') {
            formDataClone.contact_phone = formDataClone.company_phone;
        }

        let responseTimeout:any;

        setErrors({});
        postProfile(formDataClone).then(res => {
            setIsLoading(false);
            if (res.type === ApiResponseType.OK) {
                if (res.payload.success)  {
                    setResponseMessage('Erfolgreich gespeichert');
                    setResponseMessageClass('success');
                    setProfile({...profile, ...formDataClone});
                    clearTimeout(responseTimeout);
                    setHasInvalidForm(false);
                    responseTimeout = setTimeout(() => {
                        setResponseMessage('');
                    }, 5000);
                }
            } else {
                let errors = res.payload.errors!;
                if (!errors.general_error) {
                    setResponseMessage('Fehler. Bitte korrigieren Sie den Fehler und versuchen Sie es erneut.');
                    setResponseMessageClass('error');
                }
                setErrors(errors);
            }
        })
    }

    useEffect(() => {
        let formDataClone = structuredClone(formData);
        getList('company_job_status').then(res => {
            let optionList:Array<IOption> = [];
            if (res) {
                res.forEach((item:any) => {
                    optionList.push({
                        value: item.id,
                        label: item.label
                    });
                });
                setCompanyJobStatusList(optionList);
                let statusesFromOptions:Array<IOption> = [];
                statusesFromOptions = optionList.filter(singleStatusOption => {
                    return profile.company_job_status === singleStatusOption.value;
                })
                if (statusesFromOptions.length > 0) {
                    formDataClone = { ...formDataClone, company_job_status: statusesFromOptions[0] }
                }
                getList('region').then(res => {
                    let optionList:Array<IOption> = [];
                    if (res) {
                        res.forEach((item:any) => {
                            optionList.push({
                                value: item.id,
                                label: item.label
                            });
                        });
                        setRegionList(optionList);
                        let regionsFromOptions:Array<IOption> = [];
                        regionsFromOptions = optionList.filter(singleRegionOption => {
                            return profile.region === singleRegionOption.value;
                        })
                        if (regionsFromOptions.length > 0) {
                            formDataClone = { ...formDataClone, region: regionsFromOptions[0] }
                        }
                        getList('branch_sectors').then(res => {
                            let optionList:Array<IOption> = [];
                            if (res) {
                                res.forEach((item:any) => {
                                    optionList.push({
                                        value: item.id,
                                        label: item.label
                                    });
                                });
                                setBranchList(optionList);
                                setBranchesLoading(false);
                                setRegionsLoading(false);
                                setCompanyJobStatusLoading(false);

                                getList('publish_address').then(res => {
                                    if (res) {
                                        let officialDataListOption = res.filter(x => x.type === 'company');
                                        if (officialDataListOption.length > 0) {
                                            let id = officialDataListOption[0].id;
                                            if (profile.publish_address && profile.publish_address.includes(id)) {
                                                setIsCompanyAdressPublicType(true);
                                            } else {
                                                setIsCompanyAdressPublicType(false);
                                            }
                                        }
                                    }
                                }).catch(() => {
                                    setApiErrors0({
                                        errors: 'Der Server ist aktuell nicht erreichbar. Bitte probieren Sie es später erneut.'
                                    });
                                    setBranchesLoading(false);
                                    setRegionsLoading(false);
                                    setCompanyJobStatusLoading(false);
                                });
                            }
                        }).catch(() => {
                            setApiErrors1({
                                errors: 'Der Server ist aktuell nicht erreichbar. Bitte probieren Sie es später erneut.'
                            });
                            setBranchesLoading(false);
                            setRegionsLoading(false);
                            setCompanyJobStatusLoading(false);
                        });
                    }
                }).catch(() => {
                    setApiErrors2({
                        errors: 'Der Server ist aktuell nicht erreichbar. Bitte probieren Sie es später erneut.'
                    });
                    setBranchesLoading(false);
                    setRegionsLoading(false);
                    setCompanyJobStatusLoading(false);
                });
            }
        }).catch(() => {
            setApiErrors3({
                errors: 'Der Server ist aktuell nicht erreichbar. Bitte probieren Sie es später erneut.'
            });
            setBranchesLoading(false);
            setRegionsLoading(false);
            setCompanyJobStatusLoading(false);
        });

        let fieldsToCheck = {
            'company_email': 'text',
        };
        if (isCompanyAdressPublicType) {
            fieldsToCheck['company_company'] = 'text';
            fieldsToCheck['company_address'] = 'text';
            fieldsToCheck['company_zip'] = 'text';
            fieldsToCheck['company_city'] = 'text';
            fieldsToCheck['company_country'] = 'text';
            fieldsToCheck['company_country'] = 'text';
        }
        if (profile.company_web && profile.company_web.length > 0) {
            fieldsToCheck['company_web'] = 'url';
        }
        let errors = checkProfileFieldsForErrors(profile, fieldsToCheck);
        if (isCompanyAdressPublicType && (!profile.company_phone || profile.company_phone.length <= 0) && (!profile.company_mobile || profile.company_mobile.length <= 0)) {
            errors['company_phone'] = 'Festnetznummer oder Mobilnummer muss angegeben werden';
            errors['company_mobile'] = 'Festnetznummer oder Mobilnummer muss angegeben werden';
        }
        if (Object.keys(errors).length > 0) {
            setHasInvalidForm(true);
            setErrors(errors);
        }
    }, [isCompanyAdressPublicType]);

    return (
        <div className="single-tab-item">
            <Form
                unSavedChanges={unSavedChanges}
                handleSubmit={handleSubmit}
                isLoading={isLoading}
                responseMessage={responseMessage}
                responseMessageClass={responseMessageClass}
                generalErrors={ errors.general_error ? errors.general_error : null}
                displayRequiredHint={true}
                hasInvalidForm={hasInvalidForm}
            >
                <TextInput
                    onChange={handleChange}
                    value={formData?.company_company}
                    label='Unternehmen/Arbeitgeber'
                    required={isCompanyAdressPublicType}
                    name='company_company'
                    error={errors['company_company']}
                />
                <TextInput
                    onChange={handleChange}
                    value={formData?.company_department}
                    label='Abteilung'
                    name='company_department'
                    error={errors['company_department']}
                />
                { companyJobStatusLoading ? (
                    <div className="form-group loading">
                        <label htmlFor="companyJobStatus">Beruflicher Status</label>
                        <input disabled></input>
                        <div className="loader"></div>
                    </div>
                ) : (
                    <ApiCheck errors={apiErrors0 ? apiErrors0 : null}>
                        <Select
                            isSearchable={true}
                            isClearable={true}
                            label='Beruflicher Status'
                            placeholder='Status auswählen'
                            name='company_job_status'
                            onChange={(e, action) => {
                                if (e) {
                                    handleSelectChange('company_job_status', e.value)
                                }
                                if (!e && action.action === 'clear') {
                                    handleSelectChange('company_job_status', '')
                                }
                            }}
                            defaultValue={formData?.company_job_status}
                            options={companyJobStatusList}
                        />
                    </ApiCheck>
                ) }
                <TextInput
                    onChange={handleChange}
                    value={formData?.company_address}
                    label='Straße, Hausnummer'
                    required={isCompanyAdressPublicType}
                    name='company_address'
                    error={errors['company_address']}
                />
                <TextInput
                    onChange={handleChange}
                    value={formData?.company_zip}
                    label='PLZ'
                    required={isCompanyAdressPublicType}
                    name='company_zip'
                    error={errors['company_zip']}
                />
                <TextInput
                    onChange={handleChange}
                    value={formData?.company_city}
                    label='Ort'
                    required={isCompanyAdressPublicType}
                    name='company_city'
                    error={errors['company_city']}
                />
                <Select
                    isSearchable={true}
                    isClearable={true}
                    label='Land'
                    isRequired={isCompanyAdressPublicType}
                    placeholder='Land auswählen'
                    name='company_country'
                    onChange={(e, action) => {
                        if (e) {
                            handleSelectChange('company_country', e.value)
                        }
                        if (!e && action.action === 'clear') {
                            handleSelectChange('company_country', '')
                        }
                    }}
                    defaultValue={formData?.company_country}
                    options={iso3166}
                    error={errors['company_country']}
                />
                <TextInput
                    onChange={(e) => {
                        handleChange(e);
                        let errorClone = {...errors}
                        let phoneValid = validatePhone(e.target.value, false, 'Festnetznummer');
                        if (phoneValid === true) {
                            delete errorClone['company_phone'];
                            setErrors(errorClone);
                        } else {
                            errorClone['company_phone'] = phoneValid;
                            setErrors(errorClone)
                        }
                    }}
                    value={formData?.company_phone}
                    label='Festnetz'
                    required={isCompanyAdressPublicType && (formData?.company_mobile === '' || formData?.company_phone !== '')}
                    name='company_phone'
                    type='tel'
                    error={errors['company_phone']}
                    placeholder="+49123456789123"
                />
                <TextInput
                    onChange={(e) => {
                        handleChange(e);
                        let errorClone = {...errors}
                        let phoneValid = validatePhone(e.target.value, false, 'Mobilnummer');
                        if (phoneValid === true) {
                            delete errorClone['company_mobile'];
                            setErrors(errorClone);
                        } else {
                            errorClone['company_mobile'] = phoneValid;
                            setErrors(errorClone)
                        }
                    }}
                    value={formData?.company_mobile}
                    label='Mobil'
                    required={isCompanyAdressPublicType && (formData?.company_phone === '' || formData?.company_mobile !== '')}
                    name='company_mobile'
                    type='tel'
                    error={errors['company_mobile']}
                    placeholder="+49123456789123"
                />
                <TextInput
                    onChange={(e) => {
                        handleChange(e);
                        let errorClone = {...errors}
                        if (!validateEmail(e.target.value)) {
                            errorClone['company_email'] = 'Bitte geben Sie eine gültige E-Mail-Adresse ein';
                            setErrors(errorClone)
                        } else {
                            delete errorClone['company_email'];
                            setErrors(errorClone);
                        }
                    }}
                    value={formData?.company_email}
                    label='E-Mail'
                    required={true}
                    name='company_email'
                    type='email'
                    error={errors['company_email']}
                    placeholder="max.mustermann@fpsb.de"
                />
                <TextInput
                    onChange={(e) => {
                        handleChange(e);
                        let errorClone = {...errors}
                        if (e.target.value.length > 0 && !validateUrl(e.target.value)) {
                            errorClone['company_web'] = 'Bitte geben Sie eine gültige URL im Format http:// oder https:// ein.';
                            setErrors(errorClone)
                        } else {
                            delete errorClone['company_web'];
                            setErrors(errorClone);
                        }
                    }}
                    value={formData?.company_web}
                    label='Internet'
                    name='company_web'
                    error={errors['company_web']}
                    placeholder="https://www.fpsb.de/"
                />
                { branchesLoading ? (
                    <div className="form-group loading">
                        <label htmlFor="branch">Branche</label>
                        <input disabled></input>
                        <div className="loader"></div>
                    </div>
                ) : (
                    <ApiCheck errors={apiErrors1 ? apiErrors1 : null}>
                        <Select
                            isSearchable={true}
                            isClearable={true}
                            menuPlacement = 'top'
                            label='Branche'
                            placeholder='Branche auswählen'
                            name='branch_sectors'
                            onChange={(e) => {
                                if (e) {
                                    handleSelectChange('branch_sectors', e)
                                }
                            }}
                            defaultValue={formData?.branch_sectors}
                            options={branchList}
                            isMulti={false}
                            error={errors['branch_sectors']}
                        />
                    </ApiCheck>
                ) }
                { regionsLoading ? (
                    <div className="form-group loading">
                        <label htmlFor="region">Region</label>
                        <input disabled></input>
                        <div className="loader"></div>
                    </div>
                ) : (
                    <ApiCheck errors={apiErrors2 ? apiErrors2 : null}>
                        <Select
                            isSearchable={true}
                            isClearable={true}
                            menuPlacement = 'top'
                            label='Region'
                            placeholder='Region auswählen'
                            name='region'
                            onChange={(e, action) => {
                                if (e) {
                                    handleSelectChange('region', e.value)
                                }
                                if (!e && action.action === 'clear') {
                                    handleSelectChange('region', '')
                                }
                            }}
                            defaultValue={formData?.region}
                            options={regionList}
                            error={errors['region']}
                        />
                    </ApiCheck>
                ) }
            </Form>
        </div>
    )
}

export default TabOfficialData;